export enum IdleFeeStatus {
  EMPTY = 'empty',
  TOO_LOW = 'too_low',
  APPROPRIATE = 'appropriate',
  TOO_HIGH = 'too_high',
  EXCEED_LIMIT = 'exceed_limit',
}
